import { useMemo } from 'react';
import { encode } from 'uqr';

/**
 * QR code drawn locally as SVG (never sent to an external service): the 2FA secret
 * must not leave the browser. One path for all dark modules keeps the DOM small.
 */
export function QrCode({
  value,
  label,
  size = 200,
}: {
  value: string;
  label: string;
  size?: number;
}) {
  const { path, modules } = useMemo(() => {
    const qr = encode(value, { ecc: 'M' });
    let d = '';
    qr.data.forEach((row, y) => {
      row.forEach((dark, x) => {
        if (dark) d += `M${String(x)} ${String(y)}h1v1h-1z`;
      });
    });
    return { path: d, modules: qr.size };
  }, [value]);
  const quiet = 4;
  const box = modules + quiet * 2;
  return (
    <svg
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`${String(-quiet)} ${String(-quiet)} ${String(box)} ${String(box)}`}
      shapeRendering="crispEdges"
      className="rounded-lg bg-white"
    >
      <rect x={-quiet} y={-quiet} width={box} height={box} fill="#fff" />
      <path d={path} fill="#000" />
    </svg>
  );
}
